import React, { useEffect, useState, Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PhoneIcon, MenuIcon, XIcon, ChevronDownIcon, MessageSquareIcon } from 'lucide-react';
const carouselImages = [{
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1JGevbSoLh1AeBrRR9hz3Q/IMG_1783.jpg',
  alt: 'Air-Mazing Air service van with company logo and contact information'
}, {
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/g1ESu8w8KwVSrBipyo747r/overhead-of-utility-workers-maintaining-outside-ai-2025-02-15-17-21-45-utc.jpg',
  alt: 'Overhead view of HVAC technicians working on multiple AC units'
}, {
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xei1JJyx2Mf4TtgbYYJJxu/service-2025-03-27-04-50-29-utc.jpg',
  alt: 'AC unit installation with professional copper line connections'
}, {
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pMsAjvDQ3F1uZefZfTBLhd/commercial-building-hvac-ceiling-installation-2025-03-15-02-41-01-utc.jpg',
  alt: 'Commercial HVAC ductwork in ceiling installation'
}, {
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dfdoXx5h84GymbJXQ9SBKB/air-conditioner-ventilation-installation-system-in-2025-03-27-06-10-19-utc.jpg',
  alt: 'Insulated HVAC ductwork installation in attic with spray foam insulation'
}, {
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/x8MwGEHpbAg9Nc14op3Ni3/for-construction-of-new-home-installation-of-an-h-2025-03-27-03-35-59-utc.jpg',
  alt: 'HVAC ductwork installation with insulated ducts in new home construction'
}];
export const Header = () => {
  const location = useLocation();
  const [currentImage, setCurrentImage] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const isHomePage = location.pathname === '/';
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage(prev => (prev + 1) % carouselImages.length);
    }, 5000);
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      clearInterval(interval);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '/',
    isExternal: false
  }, {
    name: 'Residential Install',
    href: '/#residential-install',
    isExternal: false
  }, {
    name: 'Emergency Services',
    href: '/#emergency-service',
    isExternal: false
  }, {
    name: 'Air Quality',
    href: '/#air-quality',
    isExternal: false
  }, {
    name: 'Insulation',
    href: '/#insulation',
    isExternal: false
  }, {
    name: 'Commercial',
    href: '/#commercial',
    isExternal: false
  }, {
    name: 'Blog',
    href: '/blog',
    isExternal: false
  }, {
    name: 'Request Service',
    href: '/#request-service',
    isExternal: false
  }];
  const scrollToSection = href => {
    if (href.startsWith('/#')) {
      // It's a hash link on the home page
      if (location.pathname !== '/') {
        // If we're not on the home page, we need to navigate there first
        window.location.href = href;
        return;
      }
      const element = document.querySelector(href.substring(1));
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    setMobileMenuOpen(false);
  };
  return <header className="relative w-full" data-id="element-238">
      {/* Navigation */}
      <nav className={`bg-white py-4 fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'shadow-lg' : 'shadow-md'}`} data-id="element-239">
        <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-240">
          <div className="flex items-center" data-id="element-241">
            <div className="flex flex-col" data-id="element-242">
              <Link to="/" className="text-2xl md:text-3xl font-bold text-blue-700 tracking-tight" data-id="element-243">
                AIR-MAZING AIR, INC.
              </Link>
              <span className="text-xs md:text-sm text-gray-600 mt-0.5" data-id="element-244">
                Serving Cape Coral - Fort Myers - Punta Gorda - Naples
              </span>
            </div>
          </div>
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-245">
            {navLinks.map(link => <Fragment key={link.name} data-id="element-246">
                {link.isExternal ? <a href={link.href} className="text-gray-700 hover:text-blue-600 font-medium transition-colors relative group" data-id="element-247">
                    {link.name}
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full" data-id="element-248"></span>
                  </a> : link.href.includes('#') ? <button onClick={() => scrollToSection(link.href)} className="text-gray-700 hover:text-blue-600 font-medium transition-colors relative group" data-id="element-249">
                    {link.name}
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full" data-id="element-250"></span>
                  </button> : <Link to={link.href} className="text-gray-700 hover:text-blue-600 font-medium transition-colors relative group" data-id="element-251">
                    {link.name}
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full" data-id="element-252"></span>
                  </Link>}
              </Fragment>)}
            <a href="tel:2398886268" className="bg-blue-600 text-white px-5 py-2.5 rounded-md font-medium flex items-center hover:bg-blue-700 transition-colors shadow-sm hover:shadow-md transform hover:-translate-y-0.5 duration-300" data-id="element-253">
              <PhoneIcon className="mr-2 h-4 w-4" data-id="element-254" />
              Call Now
            </a>
          </div>
          {/* Mobile menu button */}
          <button className="md:hidden text-gray-700 focus:outline-none" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-255">
            {mobileMenuOpen ? <XIcon size={24} data-id="element-256" /> : <MenuIcon size={24} data-id="element-257" />}
          </button>
        </div>
        {/* Mobile Navigation */}
        {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-md z-20 transition-all duration-300 max-h-[70vh] overflow-y-auto" data-id="element-258">
            <div className="px-4 py-3 space-y-3" data-id="element-259">
              {navLinks.map(link => <Fragment key={link.name} data-id="element-260">
                  {link.isExternal ? <a href={link.href} className="block w-full text-left py-2.5 text-gray-700 hover:text-blue-600 font-medium transition-colors border-b border-gray-100" onClick={() => setMobileMenuOpen(false)} data-id="element-261">
                      {link.name}
                    </a> : link.href.includes('#') ? <button onClick={() => scrollToSection(link.href)} className="block w-full text-left py-2.5 text-gray-700 hover:text-blue-600 font-medium transition-colors border-b border-gray-100" data-id="element-262">
                      {link.name}
                    </button> : <Link to={link.href} className="block w-full text-left py-2.5 text-gray-700 hover:text-blue-600 font-medium transition-colors border-b border-gray-100" onClick={() => setMobileMenuOpen(false)} data-id="element-263">
                      {link.name}
                    </Link>}
                </Fragment>)}
              <a href="tel:2398886268" className="block py-2.5 text-blue-600 font-bold flex items-center transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-264">
                <PhoneIcon className="mr-2 h-4 w-4" data-id="element-265" />
                Call: 239-888-6268
              </a>
            </div>
          </div>}
      </nav>
      {/* Spacer to push content below fixed nav */}
      <div className="h-[72px]" data-id="element-266"></div>
      {/* Hero Section with Carousel - Only show on homepage */}
      {isHomePage && <div className="relative h-[600px] md:h-[700px] w-full overflow-hidden" data-id="element-267">
          {carouselImages.map((image, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-1000 ${index === currentImage ? 'opacity-100' : 'opacity-0'}`} data-id="element-268">
              <img src={image.url} alt={image.alt} className="w-full h-full object-cover" data-id="element-269" />
              <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" data-id="element-270"></div>
            </div>)}
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-4" data-id="element-271">
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-6 max-w-4xl leading-tight animate-fade-in-up" data-id="element-272">
              Professional Local HVAC Services
            </h2>
            <p className="text-xl md:text-2xl text-center mb-10 max-w-3xl animate-fade-in-up animation-delay-300" data-id="element-273">
              Over 10 years of experience providing high-quality AC
              installation, repair, and maintenance in Southwest Florida.
            </p>
            <div className="flex flex-col sm:flex-row gap-5 animate-fade-in-up animation-delay-600" data-id="element-274">
              <button onClick={() => scrollToSection('/#request-service')} className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3.5 rounded-md font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1" data-id="element-275">
                Request Service
              </button>
              <a href="tel:12398886268" className="bg-red-600 hover:bg-red-700 text-white px-8 py-3.5 rounded-md font-bold text-lg flex items-center justify-center transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1" data-id="element-276">
                <PhoneIcon className="mr-2" data-id="element-277" />
                Call: 239-888-6268
              </a>
              <a href="sms:12398886268" className="bg-green-600 hover:bg-green-700 text-white px-8 py-3.5 rounded-md font-bold text-lg flex items-center justify-center transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1" data-id="element-278">
                <MessageSquareIcon className="mr-2" data-id="element-279" />
                Text Us
              </a>
            </div>
          </div>
          {/* Scroll indicator */}
          <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce" data-id="element-280">
            <button onClick={() => scrollToSection('/#emergency')} aria-label="Scroll down" className="bg-white/20 backdrop-blur-sm hover:bg-white/30 p-3 rounded-full transition-colors duration-300" data-id="element-281">
              <ChevronDownIcon className="h-6 w-6 text-white" data-id="element-282" />
            </button>
          </div>
          {/* Carousel indicators */}
          <div className="absolute bottom-5 left-1/2 transform -translate-x-1/2 flex space-x-2" data-id="element-283">
            {carouselImages.map((_, index) => <button key={index} onClick={() => setCurrentImage(index)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${index === currentImage ? 'bg-white w-6' : 'bg-white/50'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-284" />)}
          </div>
        </div>}
    </header>;
};